import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-act-status-menu',
  templateUrl: './act-status-menu.component.html',
  styleUrls: ['./act-status-menu.component.css']
})
export class ActStatusMenuComponent implements OnInit {
    actStatusKeyno;

    public menu?: Menu;

    public activityStatusNameButtons: FormButton[] = [{
        id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'actstatuslangs', gotoParms: () => ({ actstatus_keyno: this.menu!.actstatus_keyno })
    }];

    constructor(private datatask: DataTaskService, private state: StateService) {
        this.actStatusKeyno = this.state.getStateParams()['actstatus_keyno'];
    }

    private async loadMenu() {
        if (!!this.actStatusKeyno) {
            this.menu = (await this.datatask.Post(1332, { actstatus_keyno: this.actStatusKeyno }))[0];
    	}
    }

    private async init() {
        this.loadMenu();
    }

    ngOnInit(): void {
        this.init();
    }
}

interface Menu {
    actstatus_keyno: string;
    actstatus_name: string;
    order: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('actStatusMenu', {
//        templateUrl: 'views/components/views/actStatusMenu/actStatusMenu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'actStatusMenuService', function ($stateParams, stateService, actStatusMenuService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let actStatusKeyno = $stateParams.actstatus_keyno;

//            vm.model = {
//                activityStatusNameButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('actstatuslangs', { actstatus_keyno: vm.model.menu.actstatus_keyno }) }
//                ],
//                menu: {}
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadMenu() {
//                vm.model.menu = (await actStatusMenuService.getMenu({ actstatus_keyno: actStatusKeyno }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadMenu();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
